var exports = {
  "D": "xcc377c0b--6ee8f5--carousel",
};

module.exports = exports;
